<template>
	<div>
		<div class="optimization-top-tabs-bar">
			<div class="tabs-container">
				<div
					v-for="tab in tabs"
					:key="tab.name"
					class="tab-item"
					:class="{active: currentTab === tab.name}"
					@click="go(tab.name)"
					:title="tab.tooltip"
				>
					<img v-if="tab.logo" :src="tab.logo" class="tab-logo" :alt="tab.label" />
					<feather-icon v-else :icon="tab.icon" class="tab-icon" />
					<span class="tab-label">{{ tab.label }}</span>
				</div>
			</div>
		</div>
		<div class="optimization-top-tabs-content">
			<slot :currentTab="currentTab" />
		</div>
	</div>
</template>

<script>
import serviroutesLogo from "@/assets/images/logo/serviroutes.svg";
import datarutasLogo from "@/assets/images/logo/datarutas.svg";

export default {
	name: "OptimizationTopTabs",
	props: {
		currentTab: {
			type: String,
			default: "Serviroutes",
		},
	},
	data() {
		return {
			tabs: [
				{
					name: "Serviroutes",
					label: "erviroutes",
					logo: serviroutesLogo,
					tooltip: "Serviroutes",
				},
				{
					name: "Datarutas",
					label: "atarutas",
					logo: datarutasLogo,
					tooltip: "Datarutas",
				},
				{
					name: "Upload",
					label: this.$t("Upload") + " " + this.$t("UploadFiles.File"),
					icon: "UploadCloudIcon",
					tooltip: this.$t("UploadFiles.File"),
				},
			],
		};
	},
	methods: {
		go(tab) {
			this.$emit("go", tab);
		},
	},
};
</script>

<style lang="scss" scoped>
.optimization-top-tabs-bar {
	width: 100%;
	background: #fff;
	box-shadow: 0 2px 28px 0 rgba(107, 33, 168, 0.07);
	z-index: 100;
	position: relative;
	.tabs-container {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0.5rem 0;
		.tab-item {
			display: flex;
			align-items: center;
			margin: 0 1.5rem;
			padding: 0.5rem 1rem;
			cursor: pointer;
			border-bottom: 3px solid transparent;
			border-radius: 10px 10px 0 0;
			transition: border 0.2s, color 0.2s, background 0.2s, box-shadow 0.2s;
			color: rgba(var(--vs-primary), 1);
			font-weight: 500;
			background: transparent;
			.tab-logo {
				margin-right: 0.1rem;
				width: 24px;
				height: 24px;
				display: inline-block;
				vertical-align: middle;
			}
			.tab-icon {
				margin-right: 0.5rem;
				font-size: 20px;
			}
			.tab-label {
				font-size: 1rem;
			}
			&.active {
				border-bottom: 3px solid rgba(var(--vs-primary), 1);
				font-weight: bold;
				color: rgba(var(--vs-primary), 1);
				background: #f3e8ff;
				box-shadow: 0 4px 6px -6px rgba(var(--vs-primary), 1);
				.wizard-main-tab-icon {
					opacity: 1;
					transform: scale(1.13);
				}
			}
		}
	}
}
.optimization-top-tabs-content {
	margin-top: 0.3rem;
}
@media (max-width: 767px) {
	.optimization-top-tabs-bar .tabs-container {
		flex-direction: column;
		.tab-item {
			margin: 0.5rem 0;
		}
	}
}
</style>
